import APIService from './APIService'

const api = APIService()

export const getSettings = () => api.get(`/settings`)
export const updateSettings = payload => api.patch(`/settings/${payload.id}`, { value: payload.value })
